import {
  I2cCheckboxGroup,
  I2cListItem, I2cRadioGroup, I2cRadio,
  I2cCheckbox, I2cRadioButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import "../../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardActivationMethod, validationInfo } from "./stringUtils";
import { validationSchemaCardActivation } from "./ValidationSchema";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
const CardActivation = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];       

  const handleValidationInfoCheckboxChange = (event) => {
    let SelectedNetworkValue;
    SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues("additional_validations_for_card_activation") ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue("additional_validations_for_card_activation", updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaCardActivation),
    mode: 'onChange',
    reValidateMode: 'onChange',
    // reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    // criteriaMode: "all",
    criteriaMode: "firstError",
    defaultValues: { 
      additional_allow_card_activation_using_app: "Yes",
      additional_validations_for_card_activation: [],
      additional_set_pin_after_card_activation: "No",
      additional_card_activation_method: "API",
    },
  });

  const fields = [ 
    "additional_allow_card_activation_using_app",
    "additional_validations_for_card_activation",
    "additional_set_pin_after_card_activation",
    "additional_card_activation_method", 
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) { 
      if(type === "credit"){
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[4]["4_1"][field] ?? "");
        });
      }
      else{
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_1"][field] ?? "");
        });
      }
      methods.trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues(); 
    if(type === "credit"){
      setAddFormData({
        ...addFormData,
       4: {
          ...addFormData["4"],
          "4_1": { ...values },
        },
      });
    }else{
      setAddFormData({
        ...addFormData,
        5: {
          ...addFormData["5"],
          "5_1": { ...values },
        },
      });
    }
  };
  const clearFields = (fields) => {
    fields.forEach((field) => methods.setValue(field, ""));
  };
  console.log("error in card activation", errors);
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length; 
    if(type === "credit"){
      if (errorsLength === 0) setFormValidStates("4_1", true);
      else setFormValidStates("4_1", false);
    }
    else{
      if (errorsLength === 0) setFormValidStates("5_1", true);
      else setFormValidStates("5_1", false);
    }
    handleValueChanges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(errors).length]);


  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Card Activation
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div> 
            <div className="custom-label">
              i2c cardholder app allows cardholders to activate their cards through the app.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="additional_allow_card_activation_using_app"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Please confirm if you would allow your cardholder to activate their card using application."
                    {...field}
                    name="additional_allow_card_activation_using_app"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value !== "Yes"){
                        clearFields([
                          "additional_card_activation_method",  
                          "additional_set_pin_after_card_activation", 
                        ]);
                        methods.setValue("additional_validations_for_card_activation",[])
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((bc, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("additional_allow_card_activation_using_app") === bc
                        }
                        value={bc}
                      >
                        {bc}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.additional_allow_card_activation_using_app &&
                    methods.formState.touchedFields.additional_allow_card_activation_using_app
                    ? true
                    : false
                }
                message={errors.additional_allow_card_activation_using_app?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {
            methods.watch("additional_allow_card_activation_using_app") === "Yes" && (
              <>
                <div i2c-grid="12">
                  <div className="custom-label mb-8">
                    How will the cards be activated?
                  </div>
                  <div className="single-field-wrapper">
                    <Controller
                      name="additional_card_activation_method"
                      control={control}
                      render={({ field }) => (
                        <I2cRadioGroup
                          onI2cChange={(e) => {
                            methods.setValue("additional_card_activation_method", e.target.value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                        >
                          <div i2c-grid="grid gap-sm">
                            {cardActivationMethod.map((cpi, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="4@md"
                                variant="receipt"
                                label={cpi}
                                sublabel=""
                                value=""
                                checked={methods.watch("additional_card_activation_method") === cpi}
                                type="checkbox"
                              >
                                <I2cRadio
                                  slot="prefix"
                                  name="credit_programType"
                                  value={cpi}
                                  filled
                                  label=""
                                  checked={
                                    methods.watch("additional_card_activation_method") === cpi
                                  }
                                />
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cRadioGroup>
                      )}
                    />
                  </div>
                </div>
                <div i2c-grid="12">
                  <div className="custom-label mb-8">
                    Please specify the information a cardholder must provide for validation or card activation:
                  </div>
                  <div className="single-field-wrapper">
                    <Controller
                      name="additional_validations_for_card_activation"
                      control={control}
                      render={({ field }) => (
                        <>
                          <I2cCheckboxGroup
                            {...field}
                            className="centeredCheckbox checkbox-margin"
                           
                          >
                            <div i2c-grid="grid gap-sm">
                              {validationInfo.map((card, index) => (
                                <I2cListItem
                                  key={index}
                                  i2c-grid="4@md"
                                  variant="receipt"
                                  label={card}
                                  sublabel=""
                                  value=""
                                  type="checkbox"
                                  checked={methods
                                    .watch("additional_validations_for_card_activation")
                                    .includes(card)}
                                  onI2cCheckboxClicked={(e) => {
                                    handleValidationInfoCheckboxChange(card);
                                  }}
                                >

                                  <I2cCheckbox
                                    slot="checkbox"
                                    name="additional_validations_for_card_activation"
                                    filled
                                    value={card}
                                    label=""
                                    ignoreTab
                                    checked={methods
                                      .watch("additional_validations_for_card_activation")
                                      .includes(card)}
                                    className="customCheckbox"
                                  ></I2cCheckbox>
                                </I2cListItem>
                              ))}
                            </div>
                          </I2cCheckboxGroup>
                          <ErrorMessage
                            show={
                              errors.additional_validations_for_card_activation &&
                                methods.formState.touchedFields.additional_validations_for_card_activation
                                ? true
                                : false
                            }
                            message={
                              errors.additional_validations_for_card_activation?.message ?? "Invalid input"
                            }
                          />
                        </>
                      )}
                    />
                  </div>
                </div>
                <div i2c-grid="12">
                  <div className="single-field-wrapper">
                    <Controller
                      name="additional_set_pin_after_card_activation"
                      control={control}
                      render={({ field }) => (
                        <I2cRadioGroup
                          label="Please confirm if you want to set PIN after card activation."
                          {...field}
                          name="additional_set_pin_after_card_activation"
                          onI2cChange={(e) => {
                            field.onChange(e);
                            methods.trigger();
                            handleValueChanges();
                          }}
                        >
                          {["Yes", "No"].map((bc, index) => (
                            <I2cRadioButton
                              key={index}
                              checked={
                                methods.watch("additional_set_pin_after_card_activation") === bc
                              }
                              value={bc}
                            >
                              {bc}
                            </I2cRadioButton>
                          ))}
                        </I2cRadioGroup>
                      )}
                    />
                    <ErrorMessage
                      show={
                        errors.additional_set_pin_after_card_activation &&
                          methods.formState.touchedFields.additional_set_pin_after_card_activation
                          ? true
                          : false
                      }
                      message={errors.additional_set_pin_after_card_activation?.message ?? "Invalid input"}
                    />
                  </div>
                </div>
              </>
            )
          }
        </div>

      </div>
    </React.Fragment>
  );
};
export default CardActivation;